import { Checkbox } from "@/components/ui/checkbox";
import { buildChecklistSections } from "@/lib/checklist";
import { labelDocument } from "@/lib/dataroom";

/**
 * SUPER-LOT 103 Phase B — Éditeur de la checklist documentaire par dossier.
 * Cases à cocher regroupées par section (Juridiques / Comptables / Autres).
 * `value` = tableau des types de documents RENDUS OBLIGATOIRES pour ce dossier.
 * Cocher/décocher une case ajoute/retire le type de cette liste.
 */
export default function DocumentChecklistEditor({ value = [], onChange, contexteAudit, typeDossier = "general", documents = [], disabled = false, idPrefix = "doc-checklist" }) {
    const sections = buildChecklistSections(contexteAudit, typeDossier, documents, value);
    const set = new Set(value);

    function toggle(type) {
        if (disabled) return;
        const next = new Set(set);
        next.has(type) ? next.delete(type) : next.add(type);
        onChange(Array.from(next));
    }

    return (
        <div data-testid={idPrefix} className="space-y-4">
            {sections.map((sec) => (
                <div key={sec.key} data-testid={`${idPrefix}-section-${sec.key}`} className="rounded-xl border border-slate-200 bg-white shadow-sm">
                    <div className="flex items-center justify-between border-b border-slate-200 bg-slate-50 px-4 py-2.5 rounded-t-xl">
                        <h4 className="text-sm font-semibold text-slate-700">{sec.label}</h4>
                        <span className="text-[10px] uppercase tracking-wider text-slate-500">{sec.items.filter((i) => i.required).length} / {sec.items.length} requis</span>
                    </div>
                    <ul className="divide-y divide-slate-100">
                        {sec.items.map((i) => (
                            <li key={i.type} className="flex items-start gap-3 px-4 py-2.5">
                                <Checkbox
                                    id={`${idPrefix}-${i.type}`}
                                    data-testid={`${idPrefix}-check-${i.type}`}
                                    checked={i.required}
                                    disabled={disabled}
                                    onCheckedChange={() => toggle(i.type)}
                                    className="mt-0.5"
                                />
                                <label htmlFor={`${idPrefix}-${i.type}`} className={`min-w-0 cursor-pointer select-none ${disabled ? "cursor-not-allowed opacity-70" : ""}`}>
                                    <span className="text-sm text-foreground">{labelDocument(i.type)}</span>
                                    <span className={`ml-2 text-[10px] uppercase tracking-wider ${i.required ? "text-rose-600 font-semibold" : "text-muted-foreground"}`}>{i.required ? "obligatoire" : "facultatif"}</span>
                                    {i.count > 0 && <span className="ml-2 text-xs text-muted-foreground">· {i.count} fichier{i.count > 1 ? "s" : ""}</span>}
                                    {i.help && <p className="text-xs text-muted-foreground/80">{i.help}</p>}
                                </label>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
}
